import { createId } from 'domain/utils';
import React from 'react';

export const useId = (prefix: string = '', suffix: string = '') => {
  return React.useMemo(() => createId(prefix, suffix), [prefix, suffix]);
};
